import { useQueries, useQueryClient } from '@tanstack/react-query';
import getFetchPickupOfferingsOptions from './get-options';
var useFetchPickupOfferings = function useFetchPickupOfferings(_ref) {
  var _storeLocations$objec;
  var skuId = _ref.skuId,
    storeLocations = _ref.storeLocations;
  var queryClient = useQueryClient();
  return useQueries({
    queries: (storeLocations === null || storeLocations === void 0 || (_storeLocations$objec = storeLocations.objects) === null || _storeLocations$objec === void 0 ? void 0 : _storeLocations$objec.map(function (_ref2) {
      var id = _ref2.id;
      return getFetchPickupOfferingsOptions({
        skuId: skuId,
        locationId: id,
        queryClient: queryClient
      });
    })) || []
  });
};
export default useFetchPickupOfferings;